import { PrivateInterceptor } from '../../../Base/interceptors/PrivateInterceptor'


export const getMasterWipOpen = async () => {
    const result = await PrivateInterceptor('Planning/MasterWip/Open', 'GET')
    return result;
}
export const getMasterWipOpenDetail = async (IdSOD) => {
    const result = await PrivateInterceptor(`Planning/MasterWip/Open/Detail/${IdSOD}`, 'GET')
    return result;
}
export const getPriorityList = async (IdSOD) => {
    const result = await PrivateInterceptor(`Planning/MasterWip/PriorityList`, 'GET')
    return result;
}

export const getPastDueList = async () => {
    const result = await PrivateInterceptor(`Planning/MasterWip/PastDueList`, 'GET')
    return result;
}

export const setMasterWipClosingControl= async (data) => {
    const result = await PrivateInterceptor(`Planning/MasterWip/ClosingControl`, 'POST',data)
    return result;
}
export const getMasterWipPlanner = async () => {
    const result = await PrivateInterceptor(`Planning/MasterWip/Open/Planner`, 'GET')
    return result;
}
export const getMasterWipPlannerOrder = async (IdSalesOrder) => {
    const result = await PrivateInterceptor(`Planning/MasterWip/Open/Planner/${IdSalesOrder}`, 'GET')
    return result;
}